import waitForFinalEvent from './WaitForEvent';
import { queryStructureFilter, queryChart, queryYearObjects } from './graphql/queries';
import { _Objects, svgInject, Toggle, Select } from './main';
import {formatZeroNum, getDateFromString, formatDate, imgtobg, formatNumObj, thumborRetinaImageUrl, getDotCenterParams, getDistanceBetweenDots, getCenterBetweenDots, getDeltaBetweenDots} from './helpers';
import { Chart, bindCharts } from './charts';

window.$ = $;

// Map

export class RegionMap {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this.$mapWrapp = _this.$container.find('.map__wrapp');
    _this.$mapView = _this.$container.find('.map__view');
    _this.$mapGrid = _this.$container.find('.map__grid');
    _this.$panZoomContainer = _this.$mapWrapp;
    _this.$mapGridDots = null;
    _this.$mapObjectsDots = null;
    _this.$mapObjectPage = $('.js-map-object-page');

    _this.panDefault = {
      zoom: 1,
      x: 0,
      y: 0
    };
    _this.pan = {
      zoom: 1,
      x: 0,
      y: 0
    };
    _this.maxZoom = 50;
    _this.isDragging = false;
    _this.lastPageX = 0;
    _this.lastPageY = 0;
    _this.pinchDistance = 1;
    _this.pinchCoef = 1;

    _this.$svg = _this.$container.find('.js-map-svg');
    _this.$regions = _this.$svg.find('.map-region');
    _this.regionLevel = 1;
    _this.oldRegionLevel = 1;
    _this.regionClicked = false;
    _this.panzoomInited = false;
    _this.backBtn = $('.js-map-back-btn');
    _this.queryData = {};
    _this.mapData = {};
    _this.state = {};
    _this.filters = {
      ready: {
        min: 0,
        max: 100,
      },
    };
    _this.defaultReportFilters = {
      districts: [],
      subjects: [],
      objects: [],
      readiness: { value: [0, 100] }
    };
    _this.reportFilters = {
    };

    _this.readinessColors = [ '#8B0000', '#FF582E', '#FFB301', '#3DCC9C', '#009966' ];

    _this.inited = false;
    _this.isLoadingStructure = false;
    _this.isFromSearch = false;

    _this.indicators = {
      general: {
        fo: {
          current: {
            count: '16',
            readiness: {
              lvl1: '112',
              lvl2: '11',
              lvl3: '10',
              lvl4: '9',
              lvl5: '8',
              average: '113',
            },
            spending: {
              average: '1622',
            },
          },
          previous: {
            count: '162',
            readiness: {
              lvl1: '477',
              lvl2: '476',
              lvl3: '475',
              lvl4: '474',
              lvl5: '473',
              average: '478',
            },
            spending: {
              average: '1622',
            },
          },
          next: {
            count: '15',
            readiness: {
              lvl1: '118',
              lvl2: '117',
              lvl3: '116',
              lvl4: '115',
              lvl5: '114',
              average: '119',
            },
            spending: {
              average: '163',
            },
          },
        },
        subj: {
          current: {
            count: '18',
            readiness: {
              lvl1: '133',
              lvl2: '132',
              lvl3: '13',
              lvl4: '12',
              lvl5: '11',
              average: '134',
            },
            spending: {
              average: '313',
            },
          },
          previous: {
            count: '182',
            readiness: {
              lvl1: '554',
              lvl2: '553',
              lvl3: '552',
              lvl4: '55',
              lvl5: '54',
              average: '555',
            },
            spending: {
              average: '313',
            },
          },
          next: {
            count: '17',
            readiness: {
              lvl1: '139',
              lvl2: '138',
              lvl3: '137',
              lvl4: '136',
              lvl5: '135',
              average: '140',
            },
            spending: {
              average: '312',
            },
          },
        },
        obj: {
          current: {
            name: '5',
            readyDate: '14',
            readiness: '9',
            eventType: '11',
          },
          previous: {
            name: '5',
            readyDate: '14',
            readiness: '9',
          },
          next: {
            name: '5',
            readyDate: '14',
            readiness: '92',
          },
        },
      },
      rightPanel: {
        objects: {
          percent: '9',
          dateIndicator: '14',
          finance: '113',
          capacity: '13',
        },
      },
    };

    _this.additiveCoords = {
      15: {
        x: 0,
        y: 3
      },
      31: {
        x: 0,
        y: 5
      },
      32: {
        x: 0,
        y: 5
      },
      45: {
        x: 0,
        y: -3
      },
      96: {
        x: 0,
        y: -2
      },
      default: {
        x: 0,
        y: 0
      }
    };

    _this.templates = {
      dots: {
        grid: '<div class="map__grid-cell__dots" />',
        dot: {
          dotBox: '<div class="map-dot" data-region-id=""> <div class="map-dot__wrapp"></div></div>',
          dotCircle: '<div class="map-dot__circle"><div class="map-dot__chart"><div class="chartbox js-chartbox _regionobjects"><div class="chart__view"> <div class="chart js-chart map-dot-chart" data-chart-id="" data-chart-type="donutCustom" data-chart-role="region-chart"></div> </div> <div class="chart__value"> <span class="js-regionobject-chart-value"></span> </div> </div> </div> </div>',
          dotObjCircle: '<div class="map-dot__circle"> <div class="map-dot__value"> <span class="js-regionobject-value"></span> </div> <div class="map-dot__icon"> <svg viewBox="0 0 17 15" xmlns="http://www.w3.org/2000/svg"> <g transform="translate(1 1)" fill="none" fill-rule="evenodd"> <path fill="#E1DFCF" d="M0 4.667h15v1H0z"/> <path fill="#6E4A52" d="M.987 5.444h13.026V14H.987z"/> <path stroke="#613741" stroke-width=".789" fill="#5A414A" fill-rule="nonzero" d="M15 4.667v-.82L7.5 0 0 3.847v.82"/> <ellipse fill="#E1DFCF" cx="7.5" cy="2.722" rx="1" ry="1"/> <path fill="#F59F5C" d="M.987 5.444h1.184v7.778H.987zM4.934 5.444h1.184v7.778H4.934zM8.882 5.444h1.184v7.778H8.882zM12.829 5.444h1.184v7.778h-1.184z"/> <path fill="#CE492F" d="M.395 13.222h2.368v1H.395zM4.342 13.222H6.71v1H4.342zM8.289 13.222h2.368v1H8.289zM12.237 13.222h2.368v1h-2.368z"/> <path fill="#CE492F" d="M.789 12.444h1.579v1H.789zM4.737 12.444h1.579v1H4.737zM8.684 12.444h1.579v1H8.684zM12.632 12.444h1.579v1h-1.579zM.789 5.444h1.579v1H.789z"/> <path fill="#E1DFCF" d="M3.158 7.972h1v2.333h-1zM7.105 7.972h1v2.333h-1zM11.053 7.972h1v2.333h-1z"/> <path fill="#CE492F" d="M4.737 5.444h1.579v1H4.737zM8.684 5.444h1.579v1H8.684zM12.632 5.444h1.579v1h-1.579z"/> </g> </svg> </div></div>',
          dotInfo: '<div class="map-dot__info"> <div class="map-dot__info-wrapp"> <div class="map-dot__title js-map-dot-link"> <p class="map-dot__region-name js-map-dot-region-name"></p> </div> <div class="map-dot__object-readiness"> <ul class="readiness__list js-map-dot-readiness-list"> </ul> </div> </div></div>',
          dotObjInfo: '<div class="map-dot__info"> <div class="map-dot__info-wrapp"> <div class="map-dot__title js-map-dot-link"> <p class="map-dot__region-name js-map-dot-region-name"></p> </div> <div class="map-dot__object-readiness js-object-readiness__date-block"> <div class="map-dot__object-readiness__date"><p class="js-map-dot-readiness-date" /><p>Ввод в эксплуатацию</p></div> </div> </div></div>',
          dotLink: '<div class="map-dot__link"> <i><img src="img/icons/i-arr-left.svg" alt="" class="svg-pic"></i> </div>',
          dotRedinessItem: '<li class="readiness__item" />',
          dotRedinessLabel: '<div class="readiness-lbl"> <div class="readiness-lbl__count"> <p class="js-map-dot-readiness-item-count"></p> </div> <div class="readiness-lbl__progress"> <div class="readiness-lbl__percent"> <p class="js-map-dot-readiness-item-percent"></p> </div> </div></div>',
          dotReadinessOnlyLabel: `<div class="readiness-lbl__count"> <p><span class="js-map-dot-readiness-item-count"></span><span class="js-map-dot-readiness-item-unit"></span></p> </div><div class="readiness-lbl">  <div class="readiness-lbl__progress"> <div class="readiness-lbl__percent"> <p class="js-map-dot-readiness-item-percent"></p> </div> </div></div>`
        },
      },
      slides: {
        slide: '<div class="mapobject__slide js-slide"> <div class="mapobject__pic"><img class="js-img js-photo-img" src="" alt=""></div></div>',
        additionalSlide: '<div class="mapobject__slide js-slide"><div class="mapobject__pic js-imgbox"><img src="img/temp/report-comp-pic.png" alt="" class="js-img js-additional-photo-img"><div class="mapobject__pic-date"><p class="js-additional-photo-date">06.07.2017</p></div></div></div>',
      },
    };

    _this.isSelectingEnabled = false;
    _this.mapGridInited = false;

    _this.$readyRanger = $('.js-readyranger._map');
    _this.RightPanel = _Objects.RightPanel;
    _this.$rightPanelChartsItems = _this.RightPanel.$container.find('.js-region-charts-item');
    _this.$watchReport = _this.RightPanel.$container.find('.js-rp-report');

    _this.mapToggle = Toggle.get('map-toggle');
    _this.toggleValue = _this.mapToggle.getValue();

    _this.init();
  }

  init() {
    let _this = this;
    let $container = _this.$container;
    let $regions = _this.$regions;
    let $backBtn = _this.backBtn;

    _this.ObjectPage = new ObjectPage('.js-map-object-page');

    $container.data('MapData', _this);
    $(window).on('resize', function () {
      waitForFinalEvent(function () {
        _this.setMapSize();
        _this.setMapCenter();
      }, 100, 'map');
    });
    _this.setMapSize();

    $container.on('selecting.enable', function () {
      _this.enableSelecting();
    });
    $container.on('selecting.disable', function () {
      _this.disableSelecting();
    });
    $container.on('selecting.disabled', function () {
      _this.setRightPanel();
    });

    $container.on('panzoom.enable', function () {
      _this.enablePanZoom();
    });
    $container.on('panzoom.enabled', function () {
      //_this.setDotsScale();
    });
    $container.on('panzoom.disable', function () {
      _this.disablePanZoom();
    });
    $container.on('panzoom.reset', function (e, callback) {
      _this.resetPanZoom();
      if (callback) {
        setTimeout(function () {
          callback();
        }, 500, 'map');
      }
    });

    $container.on('level.changed', function (e, level) {
      _this.$container.add($('html')).removeClass('map_level_1 map_level_2 map_level_3 map_level_4');
      _this.$container.add($('html')).addClass('map_level_' + level);
    });
    $container.on('region.change', function (e, $region) {
    });
    $container.on('region.changed', function (e, $region) {
      let regionId = $region.data('region-id') || null;
      _this.getSelectedRegionData(regionId);
      _this.setRightPanel(regionId);
    });

    $container.on('rightpanel.hidden', function (e) {
      $container.removeClass('_right-panel-active');
    });
    $container.on('rightpanel.showed', function (e) {
      $container.addClass('_right-panel-active');
    });

    $backBtn.on('click', function (e) {
      e.preventDefault();
      let $regions = _this.$regions;

      if (_this.regionLevel === 1) return false;
      let $currRegion;

      if (_this.regionLevel === 4) {
        const parentRegionId = _this.$mapObjectPage.data('parent-region-id');
        let parentRegionType = parentRegionId.split('-')[ 0 ];
        $currRegion = _this.$regions.filter('[data-region-id=' + parentRegionId + ']');
        _this.setRegionLevel((parentRegionType === 'fo') ? 2 : --_this.regionLevel);
        _this.toggleObjectPage(false);

      } else {
        $currRegion = $regions.filter('._selected').parent($regions);
        _this.setRegionLevel(_this.regionLevel - 1);
      }
      _this.setSelectedRegion($currRegion);
      _this.updateMapDots();
    });

    _Objects.Timeline.$container.on('changed', function () {
      _this.updateMapData();
    });

    _Objects.Filters.Period.$container.on('changed', function () {
      if (_this.inited) {
        setTimeout(() => {
          _this.updateMapData();
        }, 200);
      }
    });

    _this.mapToggle.$container.on('changed', (e) => {
      _this.toggleValue = _this.mapToggle.getValue();
      _this.filterRegions();
      _this.updateMapDots();
    });

    _this.$readyRanger.on('changed', (e, values) => {
      _this.filters.ready.min = Math.round(+values[ 0 ]);
      _this.filters.ready.max = Math.round(+values[ 1 ]);

      _this.filterRegions();
    });
    _this.setRegionLevel();
    _this.initRegionsGrid();
    _this.initMapDots();
    _this.dataUpdatingPromise = _this.updateMapData();
    //_this.initPanZoom();
  }

  initRegionsGrid() {
    let _this = this;
    // let $container = _this.$container;

    let $mapView = _this.$mapView;
    let $svg = _this.$svg;
    let $griWrapp = $svg;
    let $mapGrid = _this.$mapGrid;
    let $gridFirstLvl = $mapGrid.filter('._lvl-1');
    let $gridSecondLvl = $mapGrid.filter('._lvl-2');
    let $gridThirdLvl = $mapGrid.filter('._lvl-3');

    let $regions = _this.$regions;
    let $regionsFirstLvl = $regions.filter('._lvl-1');
    let $regionsSecondLvl = $regions.filter('._lvl-2');

    let mapWrappBounds = _this.getRegionBounds($griWrapp);
    let $mapLeft = mapWrappBounds.left;
    let $mapTop = mapWrappBounds.top;
    let $mapWidth = mapWrappBounds.width;
    let $mapHeight = mapWrappBounds.height;

    $.each($regionsFirstLvl, function (i, region) {
      let $currRegion = $(region);
      let regionId = $currRegion.data('region-id');
      let regionName = $currRegion.data('region-name');
      let regionBounds = _this.getRegionBounds($currRegion);

      let regionLeft = regionBounds.left - $mapLeft;
      let regiontop = regionBounds.top - $mapTop;
      let regionWidth = regionBounds.width;
      let regionHeight = regionBounds.height;

      let $gridCell = $('<div class="map__grid-cell" data-region-lvl="1" data-region-name="' + regionName + '" data-region-id="' + regionId + '" />');
      $gridCell.css({
        'left': regionLeft * 100 / $mapWidth + '%',
        'top': regiontop * 100 / $mapHeight + '%',
        'width': regionWidth * 100 / $mapWidth + '%',
        'height': regionHeight * 100 / $mapHeight + '%',
      });

      $gridFirstLvl.append($gridCell);
    });

    $.each($regionsSecondLvl, function (i, region) {
      let $currRegion = $(region);
      let regionId = $currRegion.data('region-id');
      let regionName = $currRegion.data('region-fullname');
      let regionBounds = _this.getRegionBounds($currRegion);

      let regionLeft = regionBounds.left - $mapLeft;
      let regiontop = regionBounds.top - $mapTop;
      let regionWidth = regionBounds.width;
      let regionHeight = regionBounds.height;

      let $gridCell = $('<div class="map__grid-cell" data-region-lvl="2" data-region-name="' + regionName + '" data-region-id="' + regionId + '" />');
      $gridCell.css({
        'left': regionLeft * 100 / $mapWidth + '%',
        'top': regiontop * 100 / $mapHeight + '%',
        'width': regionWidth * 100 / $mapWidth + '%',
        'height': regionHeight * 100 / $mapHeight + '%',
      });

      $gridSecondLvl.append($gridCell);
    });

    $.each($regionsSecondLvl, function (i, region) {
      let $currRegion = $(region);
      let regionId = $currRegion.data('region-id');
      let regionName = $currRegion.data('region-fullname');
      let regionBounds = _this.getRegionBounds($currRegion);

      let regionLeft = regionBounds.left - $mapLeft;
      let regiontop = regionBounds.top - $mapTop;
      let regionWidth = regionBounds.width;
      let regionHeight = regionBounds.height;

      let $gridCell = $('<div class="map__grid-cell" data-region-lvl="3" data-region-name="' + regionName + '" data-region-id="' + regionId + '" />');
      $gridCell.css({
        'left': regionLeft * 100 / $mapWidth + '%',
        'top': regiontop * 100 / $mapHeight + '%',
        'width': regionWidth * 100 / $mapWidth + '%',
        'height': regionHeight * 100 / $mapHeight + '%',
      });

      $gridThirdLvl.append($gridCell);
    });

    $mapView.addClass('_grid-set');

    _this.$mapGridCell = $mapGrid.find('.map__grid-cell');

    _this.initRegionsDots();
  }

  initRegionsDots() {
    let _this = this;
    let $mapGridCell = _this.$mapGridCell.not('[data-region-lvl="3"]');
    let dotTmpl = _this.templates.dots;

    $.each($mapGridCell, function (i, cell) {
      let $currCell = $(cell);
      let $dotsGrid = $(dotTmpl.grid);

      let $dot = _this.getDotMarkdown($currCell.data());

      $currCell.append($dotsGrid.append($dot));
    });

    _this.$mapGridDots = _this.$mapGrid.find('.map-dot');
    _this.$mapLoaders = _this.$mapGrid.find('.loader');
  }

  initObjectsDots() {
    let _this = this;
    let $mapGridCell = _this.$mapGridCell.filter('[data-region-lvl="3"]');
    let dotTmpl = _this.templates.dots;
    const mapData = _Objects.MapData;
    const mapViewBox = _this.$mapView.find('.js-map-svg').attr('viewBox').split(' ').map(v => +v);
    const objectsToChange = Object.keys(_this.additiveCoords);
    const period = _Objects.Filters.Period.getValue()[ 0 ].value;

    if (mapData.hasData()) {
      if (!mapData.hasStructureElements('subject')) {
        return;
      }
      $.each($mapGridCell, function (i, cell) {
        let $currCell = $(cell);
        let $dotsGrid = $(dotTmpl.grid);
        const subjectID = formatZeroNum(+$currCell.data('region-id').split('-')[ 1 ]);
        const subject = mapData.findStructureElementByName('subject', subjectID);
        const cellXPercent = cell.style.left.match(/^(.*)%/)[1] / 100;  //Заменено для поддержки иос 9
        const cellYPercent = cell.style.top.match(/^(.*)%/)[1] / 100;
        const cellWidthPercent = cell.style.width.match(/^(.*)%/)[1] / 100;
        const cellHeightPercent = cell.style.height.match(/^(.*)%/)[1] / 100;
        const cellX = mapViewBox[0] + cellXPercent * mapViewBox[2];
        const cellY = mapViewBox[1] + cellYPercent * mapViewBox[3];
        const cellWidth = cellWidthPercent * mapViewBox[2];
        const cellHeight = cellHeightPercent * mapViewBox[3];

        if (subject && subject.objects.length > 0) {
          $currCell.empty();
          let iObject = 0;
          let objects = subject.objects;

          if (period === 'current') {
            objects = objects.filter((object) => {
              return object.fromCurrentYear;
            });
          } else if (period === 'previous' || period === 'next') {
            objects = objects.filter((object) => {
              return object.beforeCurrentYear;
            });
          }

          objects.forEach((object) => {
            const $dot = _this.getDotMarkdown({
              regionId: `obj-${object.name}`,
              parentId: $currCell.data('region-id'),
            });
            $dot.addClass('object-dot');

            let left;
            let top;
            if (object.xConv && object.yConv) {
              if (Math.abs((object.xConv - cellX) / cellWidth) > 1
                || Math.abs((-object.yConv - cellY) / cellHeight) > 1) {
                left = iObject + 50 + '%';
                top = iObject + 50 + '%';
                iObject++;
              } else {
                const {x: addX, y: addY} = (objectsToChange.includes(object.name))
                  ? _this.additiveCoords[object.name] : _this.additiveCoords['default'];
                const xCoord = object.xConv - cellX;
                const yCoord = -object.yConv - cellY;
                left = xCoord / cellWidth * 100 + addX + '%';
                top = yCoord / cellHeight * 100 + addY + '%';
              }
            } else {
              left = 50 + 2.5 * iObject + '%';
              top = 50 + 2.5 * iObject + '%';
              iObject++;
            }
            // Can't use css here for some reason...
            $dot.attr('style', `left: ${left}; top: ${top}`);

            $dotsGrid.append($dot);
          });
          $currCell.append($dotsGrid);
        }
      });
    }

    _this.$mapObjectsDots = _this.$mapGrid.find('.map-dot.object-dot');
  }

  updateObjectsDotsLocation() {
    const $currentCell = this.$mapGrid.find('.map__grid-cell._visible');
    const $objectDots = $currentCell.find('.object-dot');
    if (!$objectDots.length) return;

    const $objectCircles = $objectDots.find('.map-dot__circle');
    const $objectInfo = $objectDots.find('.map-dot__info');
    const {width} = $objectCircles[0].getBoundingClientRect();
    const deltas = [...Array($objectCircles.length)].map(() => Array());

    for (let i = 0; i < $objectCircles.length; ++i) {
      const deltasFirst = deltas[i];
      const objFirstCenter = getDotCenterParams($objectCircles[i]);
      for (let j = i + 1; j < $objectCircles.length; ++j) {
        const deltasSecond = deltas[j];
        const objSecondCenter = getDotCenterParams($objectCircles[j]);
        const distance = getDistanceBetweenDots(objFirstCenter, objSecondCenter);
        const betweenCenter = getCenterBetweenDots(objFirstCenter, objSecondCenter);
        const distanceCoef = width / distance;
        if (distance < width) {
          const deltaFirst = getDeltaBetweenDots(objFirstCenter, betweenCenter, distanceCoef);
          const deltaSecond = getDeltaBetweenDots(objSecondCenter, betweenCenter, distanceCoef);
          deltasFirst.push(deltaFirst);
          deltasSecond.push(deltaSecond);
        }
      }
    }

    const translates = deltas.map((obj) => {
      return obj.reduce(({x, y}, acc) => {
        return ({x: acc.x + x, y: acc.y + y});
      }, {x: 0, y: 0});
    });

    $objectCircles.each((i, elem) => {
      const $elem = $(elem);
      const oldX = $elem.css('left');
      const oldY = $elem.css('top');
      $elem.css({
        'left': translates[i].x + oldX,
        'top': translates[i].y + oldY
      })
    });

    $objectInfo.each((i, elem) => {
      const $elem = $(elem);
      const oldX = $elem.css('left');
      const oldY = $elem.css('top');
      $elem.css({
        'left': translates[i].x + oldX,
        'top': translates[i].y + oldY
      })
    });
  }

  initMapDots() {
    let _this = this;

    let $dots = _this.$mapGridDots.add(_this.$mapObjectsDots);
    const $mobileDotInfo = $('.map__wrapp .map-dot__info._mobile');

    $dots.off('click.map').on('click.map', function (e) {
      e.preventDefault();
      let $currDot = $(this);
      $dots.removeClass('_hovered');
      $currDot.addClass('_hovered');
      if (window.isMobile && !window.isTablet) {
        _this.initDotInfo($currDot);
      }

      $(document).off('click.mapoff').on('click.mapoff', function (e) {
        if (!$.contains($currDot.get(0), e.target) && !$.contains($mobileDotInfo.get(0), e.target) && $mobileDotInfo.get(0) !== e.target && $currDot.get(0) !== e.target) {
          closeWindow();
          $(document).off('click.mapoff');
        }
      });

      $(document).off('touchstart.mapoff').on('touchstart.mapoff', function (e) {
        if (!$.contains($currDot.get(0), e.target) && !$.contains($mobileDotInfo.get(0), e.target) && $mobileDotInfo.get(0) !== e.target && $currDot.get(0) !== e.target) {
          if (e.touches.length === 1) {
            closeWindow();
            $(document).off('touchstart.mapoff');
          }
        }
      });
    });

    function closeWindow() {
      $dots.filter('._hovered').removeClass('_hovered');
      $mobileDotInfo.removeClass('_visible');
    }

    let startX;
    let startY;
    $dots.off('touchstart.map').on('touchstart.map', function (e) {
      if (e.touches.length === 1) {
        startX = e.touches[0].pageX;
        startY = e.touches[0].pageY;
      }
    });
    $dots.off('touchend.map').on('touchend.map', function (e) {
      if (e.touches.length === 0 && e.changedTouches.length === 1) {
        const x = e.changedTouches[0].pageX;
        const y = e.changedTouches[0].pageY;

        if (Math.hypot(x - startX, y - startY) < 10) {
          $(e.target).trigger('click');
        }
      }
    });
  }

  initDotInfo($dot) {
    const regionId = $dot.data('region-id');
    const readinessLvl = $dot.data('readiness');
    const $dotInfoMarkdown = $dot.find('.map-dot__info').children().clone(true, true);
    const $chartMarkdown = $dot.find('.map-dot__circle').clone(true, true);
    const $mobileDotInfoMarkdown = $('.map__wrapp .map-dot__info._mobile');
    $chartMarkdown.css({left:'', top: ''});

    $mobileDotInfoMarkdown.data('region-id', regionId).attr('data-region-id', regionId);
    $mobileDotInfoMarkdown.removeAttr('data-readiness');
    $mobileDotInfoMarkdown.data('readiness', readinessLvl).attr('data-readiness', readinessLvl);
    $mobileDotInfoMarkdown.empty();
    $mobileDotInfoMarkdown.append([$dotInfoMarkdown, $chartMarkdown]);
    $mobileDotInfoMarkdown.addClass('_visible');
  }

  getDotMarkdown(data) {
    let _this = this;
    let tmpl = _this.templates.dots;
    let loaderTmpl = _Objects.templates.loader;

    let $dot = $(tmpl.dot.dotBox);
    let $dotCircle = $(tmpl.dot.dotCircle);
    let $dotInfo = $(tmpl.dot.dotInfo);
    let $dotLink = $(tmpl.dot.dotLink);

    $dot.data('region-id', data.regionId).attr('data-region-id', data.regionId);
    $dot.data('parent-id', data.parentId || null).attr('data-parent-id', data.parentId || null);

    if (data.parentId) {
      $dotCircle = $(tmpl.dot.dotObjCircle);
      $dotInfo = $(tmpl.dot.dotObjInfo);
    } else {
      // chart
      let $dotChart = $dotCircle.find('.js-chart');
      let $dotChartBox = $dotCircle.find('.js-chartbox');
      $dotChart.data('colors', _this.readinessColors);
      $dotChart.add($dotChartBox).data('chart-id', data.regionId).attr('data-chart-id', data.regionId);
      $dotChart.attr('id', `chart_${data.regionId}`);

      // title
      let $dotTitle = $dotInfo.find('.js-map-dot-region-name');
      $dotTitle.text(data.regionName || '-');
    }

    $dotInfo.find('.map-dot__title').append($dotLink);
    $dot.append($dotCircle.append($(loaderTmpl))).append($dotInfo);
    svgInject($dot.find('.svg-pic'));

    return $dot;
  }

  initSelecting() {
    let _this = this;
    let $mapView = _this.$mapView;
    let $mapWrapp = _this.$mapWrapp;

    let $regions = _this.$regions;
    let $dots = _this.$mapGridDots.add(_this.$mapObjectsDots);

    if (!$dots || !$dots.length) return false;
    let $links = $dots.find('.js-map-dot-link');
    if (window.isMobile && !window.isTablet) {
      $links = $('.js-mobile-map-dot-info');
    }
    const event = window.isMobile ? 'touchend' : 'click';

    $links.off('click touchend').on(event, function (e) {
      e.preventDefault();
      let $currLink = $(this);
      // if (_this.isLoadingStructure) return false;
      if ($currLink.closest(_this.$mapGridCell).is('._loading')) return false;

      let regionId;
      if (window.isMobile && !window.isTablet) {
        $currLink.removeClass('_visible');
        regionId = $currLink.data('region-id');
      } else {
        let $currDot = $currLink.closest($dots);
        regionId = $currDot.data('region-id');
      }
      // const parentId = $currDot.data('parent-id');
      let $currRegion = $regions.filter('[data-region-id="' + regionId + '"]');
      _this.setRegionLevel(_this.regionLevel + 1);
      if (_this.regionLevel === 4) {
        _this.setSelectedObject(regionId);
      } else {
        _this.setSelectedRegion($currRegion);
      }

    });
  }

  resetSelecting() {
    let _this = this;
    let $container = _this.$container;
    let $mapWrapp = _this.$mapWrapp;

    let $regions = _this.$regions;
    $regions.removeClass('_selected');
    $container.toggleClass('map_active', _this.isSelectingEnabled);

    _this.setRegionLevel();
    _this.pan.zoom = 1;

    if (_this.isSelectingEnabled) {
      _this.initSelecting();
      if (!_this.isFromSearch) {
        _this.setSelectedRegion($regions.filter('._lvl-0'), 750)
      } else {
        _this.isFromSearch = false; // Фрагмент с isFromSearch добавлен, чтобы карта не центрировалась 2 раза, когда мы переходим на объект с меню поиска
      }
    }
  }

  resetData() {
    let _this = this;

    $.each(_this.$regions, (i, region) => {
      const $region = $(region);
      $region.removeClass('_inited');
      $region.removeClass('_active');
    });
    _this.$mapGridDots.removeClass('_has-objects');

    const mapData = _Objects.MapData;
    let lvl = _this.regionLevel;
    const hasCurrentYearData = mapData.hasData(true);
    let hasCurrentRegionData = true;

    if (lvl !== 1) {
      const selectedID = _this.$regions.filter('._selected').data('region-id');
      const [ structureName, structureId ] = selectedID.split('-');
      const structureStr = (structureName !== 'obj' && structureId < 10) ? '0' + structureId : '' + structureId;

      let fullStructureType = '';
      if (structureName === 'fo') {
        fullStructureType = 'district';
      } else if (structureName === 'subj') {
        fullStructureType = 'subject';
      } else {
        fullStructureType = 'object';
      }

      hasCurrentRegionData = mapData.hasStructureInfo(`${fullStructureType}sData`, structureStr);
    }

    if (!hasCurrentYearData || !hasCurrentRegionData) {
      switch (lvl) {
        case 2:
          _this.setRegionLevel(1);
          _this.setSelectedRegion(_this.$regions.filter('._lvl-0'));
          break;
        case 3:
          _this.setRegionLevel(1);
          _this.setSelectedRegion(_this.$regions.filter('._lvl-0'));
          break;
        case 4:
          const $objectPage = $('.js-map-object-page');
          $objectPage.removeClass('_active');
          _this.$mapWrapp.show();
          _this.setRegionLevel(1);
          _this.setSelectedRegion(_this.$regions.filter('._lvl-0'));
          break;
        default:
          break;
      }
    }
  }

  enablePanZoom() {
    const _this = this;
    const $container = _this.$container;
    const $panZoomContainer = _this.$panZoomContainer;
    const $mapView = _this.$svg;
    const mapBounds = _this.getRegionBounds($mapView);
    _this.pan = {
      ..._this.panDefault,
      defaultWidth: mapBounds.width,
      defaultHeight: mapBounds.height
    };

    $panZoomContainer.css({
      'cursor': 'move'
    });

    $panZoomContainer.on('mousedown touchstart', (e) => {
      if (e.type === 'mousedown' && e.which === 1
        || e.type === 'touchstart') {
        _this.onDragStart(e);
      }
    });

    $(document).on('mouseup touchend', (e) => {
      if (e.type === 'mouseup' && e.which === 1
        || e.type === 'touchend') {
        _this.onDragEnd(e);
      }
    });

    $container.trigger('panzoom.enabled');
  }

  onDragStart(e) {
    e.preventDefault();
    // e.stopPropagation();

    const _this = this;
    const $panZoomContainer = _this.$panZoomContainer;
    let pageCoords = {}, distance = 1;

    if (e.type === 'touchstart') {
      if (e.touches.length === 1) {
        const { pageX, pageY } = e.touches[0];
        pageCoords = {pageX, pageY};
      } else if (e.touches.length === 2) {
        const pinchParams = _this.getPinchParams(e.touches[0], e.touches[1]);
        pageCoords = pinchParams.point;
        distance = pinchParams.distance;
        _this.pinchDistance = distance;
      }
    } else {
      pageCoords = {pageX: e.pageX, pageY: e.pageY};
    }

    _this.lastPageX = pageCoords.pageX;
    _this.lastPageY = pageCoords.pageY;
    _this.isDragging = true;
    $panZoomContainer.off('mousemove touchmove').on('mousemove touchmove', (ev) => {
      _this.onDragMove(ev);
    });
  }

  onDragMove(e) {
    e.preventDefault();
    const _this = this;
    _this.$container.removeClass('_panning');
    let pageCoords = {}, distance = 1;
    let maxZoomed = false;

    if (!_this.isDragging) return;

    _this.pinchCoef = 1;

    if (e.type === 'touchmove') {
      if (e.touches.length === 1) {
        const { pageX, pageY } = e.touches[0];
        pageCoords = {pageX, pageY};
      } else if (e.touches.length === 2) {
        const pinchParams = _this.getPinchParams(e.touches[0], e.touches[1]);
        pageCoords = pinchParams.point;
        distance = pinchParams.distance;

        const pinchCoef = distance / _this.pinchDistance;
        _this.pinchCoef = pinchCoef;

        const newZoom = _this.pan.zoom * pinchCoef;
        if (newZoom <= _this.maxZoom) {
          _this.pan.zoom *= pinchCoef;
          _this.pinchDistance = distance;
        } else {
          maxZoomed = true;
        }
      }
    } else {
      pageCoords = {pageX: e.pageX, pageY: e.pageY};
    }

    if (maxZoomed) return;

    const wrapperBounds = _this.getRegionBounds(_this.$mapWrapp);
    const wrapperX = wrapperBounds.left;
    const wrapperY = wrapperBounds.top;

    const newX = ((pageCoords.pageX - _this.lastPageX + _this.pan.x + wrapperX) - pageCoords.pageX) * _this.pinchCoef + pageCoords.pageX - wrapperX;
    const newY = ((pageCoords.pageY - _this.lastPageY + _this.pan.y + wrapperY) - pageCoords.pageY) * _this.pinchCoef + pageCoords.pageY - wrapperY;

    _this.lastPageX = pageCoords.pageX;
    _this.lastPageY = pageCoords.pageY;
    _this.pan.x = newX;
    _this.pan.y = newY;

    _this.applyTransform();
  }

  getPinchParams(firstTouch, secondTouch) {
    return {
      point: {
        pageX: Math.round((firstTouch.pageX + secondTouch.pageX) / 2),
        pageY: Math.round((firstTouch.pageY + secondTouch.pageY) / 2)
      },
      distance: Math.hypot(firstTouch.pageX - secondTouch.pageX, firstTouch.pageY - secondTouch.pageY)
    };
  }

  onDragEnd() {
    const _this = this;
    const $panZoomContainer = _this.$panZoomContainer;
    _this.isDragging = false;
    $panZoomContainer.off('mousemove touchmove');
  }

  disablePanZoom() {
    let _this = this;
    let $panZoomContainer = _this.$panZoomContainer;
    _this.$container.removeClass('_panning');

    $panZoomContainer.off('mousedown mouseup mousemove ' +
      'touchend touchstart touchmove');
  }

  resetPanZoom() {
    let _this = this;
    const $mapView = _this.$mapView;
    const $panZoomContainer = _this.$panZoomContainer;
    _this.pan = {..._this.panDefault};
    $mapView.css({
      height: '',
      width: '',
      left: '',
      top: ''
    });

    $panZoomContainer.css({
      'cursor': '',
      'height': ''
    });
  }

  applyTransform() {
    const _this = this;

    const $mapView = _this.$mapView;
    $mapView.css({
      height: _this.pan.defaultHeight * _this.pan.zoom,
      width: _this.pan.defaultWidth * _this.pan.zoom,
      left: _this.pan.x,
      top: _this.pan.y
    });
  }

  enableSelecting() {
    let _this = this;

    _this.isSelectingEnabled = true;
    _this.resetSelecting();
  }

  disableSelecting() {
    let _this = this;
    let $container = _this.$container;

    _this.isSelectingEnabled = false;
    _this.resetSelecting();
    $container.trigger('selecting.disabled');
  }

  setRegionsInfo($selectedRegion) {
    let _this = this;
    let $regions = _this.$regions;
    let $dots = _this.$mapGridDots.add(_this.$mapObjectsDots);
    const mapData = _Objects.MapData;
    let period = _Objects.Filters.Period.getValue()[ 0 ].value;
    let indicators = _this.indicators.general;
    const currentYear = _Objects.Timeline.getValue();
    const currentToggle = _this.mapToggle.getValue();

    if (!mapData.hasData(true)) return;
    $selectedRegion = $selectedRegion || $regions.filter('._lvl-0');
    let lvl = +$selectedRegion.data('region-lvl');

    function getReadyCount(indicators, data) {
      return {
        objCount: _this.getDataObject(data, indicators.count).value || 0,
        ready: {
          count: {
            objReadyCountLvl1: +_this.getDataObject(data, indicators.readiness[ 'lvl1' ]).value || 0,
            objReadyCountLvl2: +_this.getDataObject(data, indicators.readiness[ 'lvl2' ]).value || 0,
            objReadyCountLvl3: +_this.getDataObject(data, indicators.readiness[ 'lvl3' ]).value || 0,
            objReadyCountLvl4: +_this.getDataObject(data, indicators.readiness[ 'lvl4' ]).value || 0,
            objReadyCountLvl5: +_this.getDataObject(data, indicators.readiness[ 'lvl5' ]).value || 0,
          },
          average: _this.getDataObject(data, indicators.readiness[ 'average' ]).value || 0,
        },
        spending: {
          average: _this.getDataObject(data, indicators.spending[ 'average' ]).value || 0,
        },
      };
    }

    function setRegionInfo(indicators, data, region, objects = []) {
      let counts = getReadyCount(indicators.main, data);
      let readinessLvl = _this.getReadinessLvl(counts.ready.average);
      const spendingLvl = _this.getReadinessLvl(counts.spending.average);

      $(region).addClass('_inited');
      region.setAttribute('data-readiness', readinessLvl);
      region.setAttribute('data-readiness-percent', counts.ready.average);
      region.setAttribute('data-spending', spendingLvl);
      region.setAttribute('data-spending-percent', counts.spending.average);

      if (+counts.objCount === 0 && lvl !== 2) return true;

      $(region).addClass('_active');

      if (lvl === 2) {
        objects.forEach((obj) => {
          const currObjData = mapData.getElementData('object', obj.name, 'static');
          let currObjInfo = JSON.parse(obj.meta);
          let dotData = {
            objName: currObjInfo.name,
            readyDate: _this.getDataObject(currObjData, indicators.sub[ 'readyDate' ]).value,
            readiness: _this.getDataObject(currObjData, indicators.sub[ 'readiness' ]).value,
          };
          dotData.readinessLvl = _this.getReadinessLvl(dotData.readiness);
          setDotInfo(`obj-${obj.name}`, dotData);
        });
      } else {
        let regionIdx = _this.getRegionId($(region));
        setDotInfo(regionIdx.id, counts);
      }
    }

    function setDotInfo(regionId, dotData) {
      let $currDot = $dots.filter('[data-region-id="' + regionId + '"]');
      $currDot.addClass('_has-objects');

      if (lvl === 2) {

        $currDot.data('readiness', dotData.readinessLvl)
          .attr('data-readiness', dotData.readinessLvl);
        $currDot.data('readiness-percent', dotData.readiness)
          .attr('data-readiness-percent', dotData.readiness);

        // circle
        let $dotValue = $currDot.find('.js-regionobject-value');
        $dotValue.text(dotData.readiness + '%');

        // title
        let $dotTitle = $currDot.find('.js-map-dot-region-name');
        $dotTitle.text(dotData.objName || '-');

        // date
        let $dotReadyDate = $currDot.find('.js-map-dot-readiness-date');
        if (!dotData.readyDate) {
          $dotReadyDate.closest('.js-object-readiness__date-block').addClass('_hidden');
        } else {
          let date = getDateFromString(dotData.readyDate);
          $dotReadyDate.text(`${formatZeroNum(+date.getDate())}.${formatZeroNum(+date.getMonth() + 1)}.${date.getFullYear()}`);
        }

      } else {
        let $dotChart = $currDot.find('.js-chart');
        const readiness = [
          dotData.ready.count.objReadyCountLvl1,
          dotData.ready.count.objReadyCountLvl2,
          dotData.ready.count.objReadyCountLvl3,
          dotData.ready.count.objReadyCountLvl4,
          dotData.ready.count.objReadyCountLvl5,
        ];
        $dotChart.data('readinessData', readiness);

        const spending = [ 0, 0, 0, 0, 0 ];
        const spendLvl = _this.getReadinessLvl(dotData.spending.average);
        spending[ spendLvl - 1 ] = dotData.objCount;
        $dotChart.data('spendingData', spending);
        $currDot.data('spending-percent', dotData.spending.average);

        const currentData = (currentToggle === 'readiness') ? readiness : spending;

        $dotChart.data('chartData', currentData);

        let _chart = Chart.get(regionId);
        if (!_chart) {
          _chart = Chart.make(regionId);
          _chart.show();
        } else {
          _chart.initChartData();
          _chart.show();
        }

        let $dotChartValue = $currDot.find('.js-regionobject-chart-value');
        $dotChartValue.text(dotData.objCount);

        let dotReadyList = $currDot.find('.js-map-dot-readiness-list');
        let readyArr = currentData.slice().reverse();

        _this.fillDotList(dotReadyList, readyArr);
      }
    }

    if (lvl === 0) {
      // indicators = indicators['fo'][period];
      indicators = {
        main: indicators[ 'fo' ][ period ],
      };
      let $currRegions = $regions.filter('._lvl-1').not('._inited');
      $.each($currRegions, (i, region) => {
        let regionIdx = _this.getRegionId($(region));

        const currData = mapData.getElementData('district', regionIdx.idNum, 'static');
        if (undefined === currData) return true;
        setRegionInfo(indicators, currData, region);
      });
    }
    if (lvl === 1) {
      // indicators = indicators['subj'][period];
      indicators = {
        main: indicators[ 'subj' ][ period ],
      };
      // let $parentRegionId = $selectedRegion.data('region-id').split('-')[1];
      let mainRegionIdx = _this.getRegionId($selectedRegion);
      const nominatedRegions = $selectedRegion.children($regions).filter('._nominated');
      const dataRegions = $selectedRegion.children($regions).filter('.data-set-' + currentYear);

      nominatedRegions.removeClass('_inited');
      dataRegions.removeClass('_inited');

      let $currRegions = $selectedRegion.children($regions).not('._inited');
      $.each($currRegions, (i, region) => {
        let regionIdx = _this.getRegionId($(region));

        const currData = mapData.getElementData('subject', regionIdx.idNum, 'static');
        if (undefined === currData) return true;
        setRegionInfo(indicators, currData, region);
      });
    }
    if (lvl === 2) {
      indicators = {
        main: indicators[ 'subj' ][ period ],
        sub: indicators[ 'obj' ][ period ],
      };
      let mainRegionIdx = _this.getRegionId($selectedRegion.closest('._lvl-1'));
      let parentRegionIdx = _this.getRegionId($selectedRegion.closest('._lvl-2'));

      let $currRegion = $selectedRegion;//.not('._inited');
      // let currRegionIdx = _this.getRegionId($currRegion);
      const parentRegionId = `${parentRegionIdx.idNum}`;
      const acceptableObjects = mapData.filterStructureElements('object', 'parentName', parentRegionId);

      const currData = mapData.getElementData('subject', parentRegionIdx.idNum, 'static');
      if (undefined === currData) return true;

      setRegionInfo(indicators, currData, $currRegion[ 0 ], acceptableObjects);
    }

    _this.filterRegions();
  }

  fillDotList(dotReadyList, readyArr) {
    const _this = this;
    const readyItemTmpl = _this.templates.dots.dot.dotRedinessItem;
    let readyLabelTmpl = _this.templates.dots.dot.dotRedinessLabel;
    const currentToggle = _this.toggleValue;
    const $mapDot = dotReadyList.closest('.map-dot');
    dotReadyList.empty();
    dotReadyList.removeClass('_only-element');
    const nonEmptyReadyArr = readyArr.reduce((acc, val, i) =>
      (val !== 0) ? acc.concat({i, item: val}) : acc, []);
    //todo ПЕРЕПИСАТЬ ФРАГМЕНТ
    if (nonEmptyReadyArr.length === 1) {
      dotReadyList.addClass('_only-element');
      readyLabelTmpl = _this.templates.dots.dot.dotReadinessOnlyLabel;
      const {i, item} = nonEmptyReadyArr[0];
      let $currReadyLabel = $(readyLabelTmpl);
      let $readyCountText = $currReadyLabel.find('.js-map-dot-readiness-item-count');
      let $readyCountUnit = $currReadyLabel.find('.js-map-dot-readiness-item-unit');
      let $readyPercentText = $currReadyLabel.find('.js-map-dot-readiness-item-percent');

      $currReadyLabel.data('readiness', readyArr.length - i).attr('data-readiness', readyArr.length - i);
      let unitObjects = ['объект', 'объекта', 'объектов'];
      $readyCountUnit.text(formatNumObj(item, unitObjects));
      $readyCountText.text(item + ' ');
      if (currentToggle === 'readiness') {
        switch (i) {
          case 0:
            $readyPercentText.text('100%');
            break;
          case 1:
            $readyPercentText.text('100-80%');
            break;
          case 2:
            $readyPercentText.text('80-50%');
            break;
          case 3:
            $readyPercentText.text('50-30%');
            break;
          case 4:
            $readyPercentText.text('30-0%');
            break;
        }
      } else {
        const percent = Math.round($mapDot.data('spending-percent'));
        $readyPercentText.text(percent + '%');
      }
      dotReadyList.append($(readyItemTmpl).append($currReadyLabel));
    } else {
      $.each(readyArr, (i, item) => {
        if (item === 0) return true;
        let $currReadyLabel = $(readyLabelTmpl);
        let $readyCountText = $currReadyLabel.find('.js-map-dot-readiness-item-count');
        let $readyPercentText = $currReadyLabel.find('.js-map-dot-readiness-item-percent');

        $currReadyLabel.data('readiness', readyArr.length - i).attr('data-readiness', readyArr.length - i);
        if (currentToggle === 'readiness') {
          $readyCountText.text(item);
          switch (i) {
            case 0:
              $readyPercentText.text('100%');
              break;
            case 1:
              $readyPercentText.text('100-80%');
              break;
            case 2:
              $readyPercentText.text('80-50%');
              break;
            case 3:
              $readyPercentText.text('50-30%');
              break;
            case 4:
              $readyPercentText.text('30-0%');
              break;
          }
        } else {
          $readyCountText.text(item);
          const percent = Math.round($mapDot.data('spending-percent'));
          $readyPercentText.text(percent + '%');
        }

        dotReadyList.append($(readyItemTmpl).append($currReadyLabel));
      });
    }
  }

  setRegionLevel(lvl) {
    let _this = this;
    let $container = _this.$container;

    _this.oldRegionLevel = (!lvl) ? 1 : _this.regionLevel;
    _this.regionLevel = (!lvl) ? 1 : +lvl;
    //_this.pinchCoef = 1;
    $container.trigger('level.changed', [ (!lvl) ? 1 : +lvl ]);
  }

  getFullStructureName(structureName) {
    switch(structureName) {
      case 'fo':
        return 'district';
      case 'subj':
        return 'subject';
      case 'obj':
        return 'object';
      default:
        return '';
    }
  }

  getFullParentName(structureName) {
    switch(structureName) {
      case 'subj':
        return 'district';
      case 'obj':
        return 'subject';
      default:
        return '';
    }
  }

  getShortParentName(structureName) {
    switch(structureName) {
      case 'subj':
        return 'fo';
      case 'obj':
        return 'subj';
      default:
        return '';
    }
  }

  getReportParams(regionId) {
    const _this = this;
    const [ structureName, structureId ] = regionId.split('-');
    const structureStr = (structureName !== 'obj' && structureId < 10) ? '0' + structureId : '' + structureId;
    const structureTypeName = _this.getFullStructureName(structureName);
    const parentTypeName = _this.getFullParentName(structureName);

    let currentReportFilterElems = _this.reportFilters[`${structureTypeName}s`];
    const structureElement = _Objects.MapData.findStructureElementByName(structureTypeName, structureStr);
    const elementWithAdditionalField = $.extend(true, {}, structureElement);
    elementWithAdditionalField.value = structureElement.name;
    elementWithAdditionalField.text = JSON.parse(structureElement.meta).name;
    currentReportFilterElems.push(elementWithAdditionalField);

    if (parentTypeName.length) {
      const parentStructureId = structureElement.parentName;
      const shortParentName = _this.getShortParentName(structureName);
      this.getReportParams(`${shortParentName}-${+parentStructureId}`);
    }

  }

  initReportButton(region) {
    const _this = this;
    _this.reportFilters = $.extend(true, {}, _this.defaultReportFilters);
    _this.getReportParams(region);
    const $button = this.$watchReport;
    $button.off('click').on('click', async () => {
      const reports = _Objects.Reports;
      reports.$container.addClass('_mobile-loading');
      reports.readyToSubmit = true;
      _Objects.RightPanel.hidePanel();
      reports.$btnGenerate.trigger('click', _this.reportFilters);
      setTimeout(() => _Objects.Page.setPage('reports'), 0);
    });
  }

  setSelectedRegion($region, delay = 0) {
    let _this = this;
    let $regions = _this.$regions;

    $region = $region || $regions.filter('._selected').not('._nominated');
    if (!$region || !$region.length) return false;

    $.each($regions, function (i, region) {
      $(region).removeClass('_selected');
      $(region).removeClass('_visible');
    });

    let $childRegions = _this.getChildrenRegions($region);
    $.each($childRegions, function (i, region) {
      $(region).addClass('_visible');
    });
    let childRegionsIdx = $.map($childRegions, (childRegion) => {
      return $(childRegion).data('region-id');
    });

    let $dots = _this.$mapGridDots.add(_this.$mapObjectsDots);
    if ($dots && $dots.length) {
      let $gridCells = _this.$mapGridCell;
      $gridCells.removeClass('_visible');

      let $currMapDots = null;
      if (_this.regionLevel > 2) {
        $currMapDots = _this.$mapObjectsDots.filter((i, dot) => {
          return $(dot).data('parent-id') === $region.data('region-id');
        });
      } else {
        $currMapDots = _this.$mapGridDots.filter((i, dot) => {
          return childRegionsIdx.indexOf($(dot).data('region-id')) > -1;
        });
      }
      let $currGridCells = $currMapDots.closest(_this.$mapGridCell);
      $currGridCells.addClass('_visible');
    }

    $region.addClass('_selected');

    _this.$container.trigger('region.change', [ $region ]);
    setTimeout(function () {
      _this.$container.trigger('region.changed', [ $region ]);
      _this.setMapCenter($region);
    }, delay);
  }

  setSelectedObject(objectId) {
    let _this = this;

    let objData = {
      id: objectId,
    };
    _this.setRegionLevel(4);
    _this.initReportButton(objectId);
    _this.toggleObjectPage(true, objData);
    _this.getSelectedObjectInfo(objectId).then(() => {
      _this.setSelectedObjectInfo(objectId);
      _this.setRightPanelInfo(objectId);
    });
  }

  getSelectedObjectInfo(objectId) {
    const _this = this;
    const objectNum = objectId.split('-')[ 1 ];
    const mapData = _Objects.MapData;
    const currentYear = _Objects.Timeline.getValue();
    if (!objectNum) {
      return false;
    }
    return new Promise(function (resolve, reject) {
      if (!mapData.hasElementDynamicData('object', objectNum)) {
        const currentObject = mapData.findStructureElementByName('object', objectNum);
        const queryParams = {
          id: currentObject.dateId,
          year: currentYear,
        };
        _this.RightPanel.$container.find('.js-region-charts-item').filter('_dynamic').removeClass('_hidden');
        const $chart = _this.RightPanel.$container.find('.js-chart:visible').filter('._dynamic');
        const $chartBox = $chart.closest('.js-chartbox');
        $chartBox.addClass('_loading');
        queryChart(queryParams).then(({ data }) => {
          mapData.setStructureIndicatorDynamicData('object', objectNum, data);
          $chartBox.removeClass('_initing _loading').addClass('_inited');
          _this.setRightPanelCharts(objectId, true);
        });
      } else {
        _this.setRightPanelCharts(objectId, true);
      }
      resolve();
    });
  }

  setSelectedObjectInfo() {
    const _this = this;
    let $objectPage = _this.ObjectPage.$container;
    const indicators = _this.indicators.general.obj.current;
    const mapData = _Objects.MapData;
    const regionId = $objectPage.data('region-id').split('-')[ 1 ];

    const objectInfo = mapData.findStructureElementByName('object', regionId);
    const objectMeta = JSON.parse(objectInfo.meta);
    const subjectInfo = mapData.findStructureElementByName('subject', objectInfo.parentName);
    const subjectMeta = JSON.parse(subjectInfo.meta);
    $objectPage.find('.js-mapobject-name').text(objectMeta.name || 'Нет информации');
    $objectPage.find('.js-mapobject-region').text(subjectMeta.name || 'Нет информации');
    $objectPage.find('.js-mapobject-desc').text(objectMeta.description || 'Нет информации');

    const objectData = mapData.getElementData('object', regionId, 'static');

    const readinessPercent = _this.getDataObject(objectData, indicators.readiness).value || 0;
    const eventType = _this.getDataObject(objectData, indicators.eventType).value || 0;
    const readinessLevel = _this.getReadinessLvl(readinessPercent);
    $objectPage.find('.js-mapobject-readiness').text(readinessPercent + '%' || 'Нет информации');
    $objectPage.find('.js-mapobject-event').text(eventType || 'Нет информации');
    $objectPage.find('.ready-label').css('background-color', _this.readinessColors[ readinessLevel - 1 ]);

    function initObjectPhotos() {
      const $buildContainer = $('.js-build-photos');
      const $mapObjectPhotosContainers = $buildContainer.find('.js-mapobject__photos');
      $mapObjectPhotosContainers.removeClass('_nodata');
      const $additionalSliderContainer = $buildContainer.find('.mapobject__sliderbox._thumbs');
      $additionalSliderContainer.addClass('_hidden');
      const { photo1, photo2, photo3, photoOther } = objectMeta;
      const mainPhotosArray = [ photo1, photo2, photo3 ];
      if (!photo1 && !photo2 && !photo3) {
        $mapObjectPhotosContainers.addClass('_nodata');
        return;
      } else {
        mainPhotosArray.forEach((photo, i) => {
          if (!photo) {
            const $tab = $buildContainer.find(`.js-mapobject__tab[data-tab="mo-${i + 1}"]`);
            $tab.find('.js-mapobject__photos').addClass('_nodata');
          }
        });
      }

      let parsedOthers = [];

      if (photoOther.length) {
        const parsed = photoOther.split(';').filter((photo) => photo.length !== 0).map((photo) => {
          const dateWithExt = photo.split('_')[ 2 ];
          const dateExtArr = dateWithExt.split('.');
          const date = dateExtArr.slice(0, dateExtArr.length - 1).join('.');
          return { date, name: photo };
        });
        parsedOthers.push(...parsed);
      }

      const mainPhotos = [ photo1, photo2, photo3 ].map((photo) => {
        let name = photo;
        if (photo) {
          if (!photo.match(/^(.*)\.jpg$/i)) {
            console.warn(`Photo '${photo}' does not end with '.jpg'`);
            name = photo + '.jpg';
          }
        }
        return [ { name }, ...parsedOthers ];
      });

      const addSlideTmpl = _this.templates.slides.additionalSlide;
      const slideTmpl = _this.templates.slides.slide;

      const additionalSlides = parsedOthers.map((photo) => {
        const $slide = $(addSlideTmpl);
        $slide.find('.js-additional-photo-img').attr('src', thumborRetinaImageUrl('preview', 'retina_preview', photo.name));
        $slide.find('.js-additional-photo-date').text(photo.date);
        return $slide;
      });

      const mainSlides = mainPhotos.map((photos) => photos.map((photo) => {
        const $slide = $(slideTmpl);
        if (photo.name && photo.name.length) {
          $slide.find('.js-photo-img').attr('src', thumborRetinaImageUrl('', 'retina', photo.name));
        } else {
          $slide.find('.js-photo-img').attr('src', '');
        }
        return $slide;
      }));

      const mainWithAdditionalSlides = [additionalSlides[0], ...additionalSlides];

      mainSlides.forEach((value, i) => {
        const $currentTab = $buildContainer.find('.js-mapobject__tab[data-tab="mo-' + (i + 1) + '"]');
        const $slider = $currentTab.find('.js-slider._main');
        const $sliderBox = $slider.closest('.mapobject__sliderbox');
        const sliderConfig = $slider.data('_slickconfig');
        $slider.slick('unslick');
        $slider.empty();
        value.forEach((photo) => $slider.append(photo.clone()));
        if(additionalSlides.length) {
          $sliderBox.removeClass('_no-additional');
          $slider.slick(sliderConfig);
          $additionalSliderContainer.removeClass('_hidden');
        } else {
          $sliderBox.addClass('_no-additional');
        }
      });

      const $additionalSliders = $buildContainer.find('.js-slider._thumbs');
      if (additionalSlides.length) {
        $additionalSliders.removeClass('_hidden');
        $additionalSliders.each((index, slider) => {
          const $slider = $(slider);
          const sliderConfig = $slider.data('_slickconfig');
          const $nextBtn = $slider.closest('.mapobject__sliderbox').find('.btn_next');
          const $prevBtn = $slider.closest('.mapobject__sliderbox').find('.btn_prev');

          $slider.slick('unslick');
          $slider.empty();

          $slider.on('afterChange', (event, slick, currentSlide) => {
            if (currentSlide === 0) {
              $prevBtn.addClass('hidden');
              $nextBtn.removeClass('hidden');
            } else if (currentSlide === mainWithAdditionalSlides.length - 1 ) {
              $nextBtn.addClass('hidden');
              $prevBtn.removeClass('hidden');
            }
            else {
              $prevBtn.removeClass('hidden');
              $nextBtn.removeClass('hidden');
            }
          });
          $slider.on('init', () => {
            $prevBtn.addClass('hidden');
          });

          mainWithAdditionalSlides.forEach((value, i) => {
            const clonedVal = value.clone();
            if (i === 0) {
              const photoName = !mainPhotos[index][0].name.length ? '' : thumborRetinaImageUrl('preview', 'retina_preview', mainPhotos[index][0].name);
              clonedVal.find('.js-additional-photo-img').attr('src', photoName);
            }
            $slider.append(clonedVal);
          });
          imgtobg($slider.find('.js-imgbox'));
          $slider.slick(sliderConfig);
        });
      }
    }

    setTimeout(() => initObjectPhotos(), 750);
  }

  setMapCenter($region) {
    let _this = this;
    let $container = _this.$container;
    let $mapView = _this.$mapView;
    let $mapWrapp = _this.$mapWrapp;
    const currentZoom = _this.pan.zoom;

    $region = $region || _this.$regions.filter('._selected').not('._nominated');
    if (!$region.length) {
      return;
    }

    $container.addClass('_panning');
    let bounds = _this.getRegionBounds($region);
    let zoom = _this.getZoomMult(bounds);
    let mapBounds = _this.getRegionBounds($mapView);
    let wrapBounds = _this.getRegionBounds($mapWrapp);

    let targetX = wrapBounds.width / 2 + wrapBounds.left;
    let targetY = wrapBounds.height / 2 + wrapBounds.top;

    let mapX = mapBounds.left;
    let mapY = mapBounds.top;

    let regionXcenter = bounds.width / 2 + bounds.left;
    let regionYcenter = bounds.height / 2 + bounds.top;

    const newX = targetX - (regionXcenter - mapX) / currentZoom * zoom + _this.pan.x - mapX;
    const newY = targetY - (regionYcenter - mapY) / currentZoom * zoom + _this.pan.y - mapY;

    _this.pan.x = newX;
    _this.pan.y = newY;
    _this.pan.zoom = zoom;

    _this.applyTransform();

    if (_this.regionLevel === 3) {
      setTimeout(() => _this.updateObjectsDotsLocation(), 500)
    }
  }

  setRightPanel(regionId) {
    let _this = this;
    let RightPanel = _this.RightPanel;

    if (!regionId) {
      _this.$container.trigger('rightpanel.hidden');
      RightPanel.hidePanel();
      return null;
    }

    RightPanel.showPanel();
    _this.initReportButton(regionId);
    _this.setRightPanelInfo(regionId);
    _this.$container.trigger('rightpanel.showed');
  }

  setRightPanelInfo(regionId) {
    if (!regionId) {
      return;
    }
    let _this = this;
    let RightPanel = _this.RightPanel;
    let $rightPanel = RightPanel.$container;
    let $rightPanelRegionName = $rightPanel.find('.js-rp-region-name');
    const mapData = _Objects.MapData;
    const [ structureName, structureId ] = regionId.split('-');
    if (structureName === 'subj') {
      const $imgbox = $rightPanel.find('.js-imgbox');
      $rightPanel.find('.js-rp-region-img').attr('src', `img/content/regions/${structureId}.png`);
      imgtobg($imgbox)
    }

    $rightPanel.removeClass('_notitle');

    if (structureName !== 'obj') {
      let $currRegion = _this.$regions.filter('[data-region-id="' + regionId + '"]');
      const regionName = (structureName === 'subj') ? $currRegion.data('region-fullname') : $currRegion.data('region-name');
      $rightPanelRegionName.text(regionName);
      _this.setRightPanelCards(regionId);
    }

    if (structureName === 'obj') {
      const objectInfo = mapData.findStructureElementByName('object', structureId);
      const objectMeta = JSON.parse(objectInfo.meta);
      const $cameras = $rightPanel.find('.js-region-object-cam');
      const $camera1 = $cameras.filter('[data-cam-id="cam-1"]');
      const $camera2 = $cameras.filter('[data-cam-id="cam-2"]');

      $cameras.show();
      const { webcam1, webcam2 } = objectMeta;

      if (!webcam1.length && !webcam2.length) {
        $cameras.hide();
        $rightPanel.addClass('_notitle');
      } else {
        if (webcam1 === '//' || !webcam1.length) {
          $camera1.hide();
        }
        if (webcam2 === '//' || !webcam2.length) {
          $camera2.hide();
        }
        $camera1.attr('href', webcam1);
        $camera2.attr('href', webcam2);
      }
    }

    _this.setRightPanelCharts(regionId, false);
  }

  setRightPanelCharts(regionId, dynamic) {
    const _this = this;
    if (dynamic) {
      _this.RightPanel.$container.find('.js-region-charts-item').filter('_dynamic').removeClass('_hidden');
    } else {
      _this.RightPanel.$container.find('.js-region-charts-item').not('_dynamic').removeClass('_hidden');
    }
    const $rpCharts = (dynamic) ? _this.RightPanel.$container.find('.js-chart:visible').filter('._dynamic')
      : _this.RightPanel.$container.find('.js-chart:visible').not('.completion-chart').not('._dynamic');

    $.each($rpCharts, (i, chart) => {
      const $currChart = $(chart);
      $currChart.attr('data-region-id', regionId).data('region-id', regionId);
      const chartID = $currChart.data('chart-id');
      if (dynamic) {
        const selectInstance = Select.get(chartID);
        if (selectInstance) selectInstance.resetValues();
      }
      const _chart = Chart.get(chartID);
      if (!_chart) {
        Chart.make(chartID).show();
      } else {
        // _chart.$chart.trigger('charts.resize');
        _chart.initChartData();
        _chart.show();
      }
    });
  }

  toggleObjectPage(isShowing = false, objData) {
    let _this = this;
    let $mapObjectPage = _this.$mapObjectPage;

    if (isShowing && objData) {
      let $objDot = _this.$mapObjectsDots.filter('[data-region-id=' + objData.id + ']');
      let parentId = $objDot.data('parent-id');

      _this.ObjectPage.setObjectData({ ...objData, parentId });
    }

    if (isShowing) _this.ObjectPage.show();
    else _this.ObjectPage.hide();
    // $mapObjectPage.toggleClass('_active', isShowing);
  }

  setRightPanelCards(regionId) {
    const _this = this;

    const mapData = _Objects.MapData;
    const [ structureName, structureId ] = regionId.split('-');
    const structureStr = (structureName !== 'obj' && structureId < 10) ? '0' + structureId : '' + structureId;
    let objectsIds = [];

    if (structureName === 'fo') {
      const selectedDistrict = mapData.findStructureElementByName('district', structureStr);
      objectsIds = selectedDistrict.subjects.reduce((acc, subj) => acc.concat(subj.objects), [])
        .map(({ name }) => name);
    } else if (structureName === 'subj') {
      objectsIds = mapData.filterStructureElements('object', 'parentName', structureStr).map(({ name }) => name);
    }

    _this.insertObjectsCards(objectsIds, regionId);
  }

  insertObjectsCards(objectsIds, regionId) {
    const _this = this;
    const mapData = _Objects.MapData;
    const $objectsItem = _this.RightPanel.$objectTemplate;
    const indicators = _this.indicators.rightPanel.objects;
    const RightPanel = _this.RightPanel;
    const $rightPanel = RightPanel.$container;
    const $objectsList = $rightPanel.find('.js-progress-steps__list');

    $objectsList.empty();

    if (!mapData.hasProperty('objectsData')) {
      return;
    }

    objectsIds.forEach((objectName) => {
      const objectWithMeta = mapData.findStructureElementByName('object', objectName);
      const objectMeta = JSON.parse(objectWithMeta.meta);
      const subjectWithMeta = mapData.findStructureElementByName('subject', objectWithMeta.parentName);
      const subjectMeta = JSON.parse(subjectWithMeta.meta);
      const $objectTemplate = $objectsItem.clone();

      if (!mapData.getElementData('object', objectName)) return;

      const objectData = mapData.getElementData('object', objectName, 'static');
      const $objectWrapp = $objectTemplate.find('.js-progress-step');
      $objectWrapp.data('parent-id', regionId).attr('data-parent-id', regionId);
      $objectWrapp.data('object-id', objectName).attr('data-object-id', objectName);
      $objectWrapp.on('click', function (e) {
        _this.setSelectedObject('obj-' + objectName);
      });

      $objectTemplate.find('.js-progress-step__name').text(objectMeta.name);
      $objectTemplate.find('.js-progress-step__region').text(subjectMeta.name);

      const dateReady = _this.getDataObject(objectData, indicators.dateIndicator).value;
      if (dateReady.length) {
        $objectTemplate.find('.js-progress-step__ready-date__date').text(formatDate(getDateFromString(dateReady)));
      } else {
        $objectTemplate.find('.js-ready-date-container').addClass('_hidden');
      }

      const infoFinance = _this.getDataObject(objectData, indicators.finance).value;
      const infoCapacity = _this.getDataObject(objectData, indicators.capacity).value;
      const $infoFinance = $objectTemplate.find('.js-progress-step__info-finance');
      const $infoCapacity = $objectTemplate.find('.js-progress-step__info-capacity');
      if (infoFinance.length) {
        $infoFinance.text(`${infoFinance} млн руб.`);
      } else {
        $infoFinance.closest('.js-progress__item').addClass('_hidden');
      }

      if (infoCapacity.length) {
        $infoCapacity.text(`${infoCapacity} чел.`);
      } else {
        $infoCapacity.closest('.js-progress__item').addClass('_hidden');
      }
      $objectsList.append($objectTemplate);

      // chart
      let objectChartValue = _this.getDataObject(objectData, indicators.percent).value;
      let $objectChartValueText = $objectTemplate.find('.js-completion-chart-value');
      if (objectChartValue.length) {
        objectChartValue = +objectChartValue;
        let objectReadinessLvl = _this.getReadinessLvl(objectChartValue);
        $objectChartValueText.text(`${objectChartValue}%`);
        let $objectChart = $objectTemplate.find('.js-chart');
        $objectChart.data('chart-id', 'completion-' + objectName)
          .attr('data-chart-id', 'completion-' + objectName);
        $objectChart.attr('id', 'chart_completion-' + objectName);
        $objectChart.data('colors', [ _this.readinessColors[ objectReadinessLvl - 1 ], '#EBECED' ]);
        $objectChart.data('chartData', [ objectChartValue, 100 - objectChartValue ]);

        bindCharts($objectChart);
        let _chart = Chart.get('completion-' + objectName);
        if (!_chart) {
          _chart = Chart.make('completion-' + objectName);
          _chart.show();
        } else {
          _chart.$chart.data('colors', [ _this.readinessColors[ objectReadinessLvl - 1 ], '#EBECED' ]);
          _chart.$chart.data('chartData', [ objectChartValue, 100 - objectChartValue ]);
          _chart.initChartData();
          _chart.show();
        }
      } else {
        $objectChartValueText.closest('.js-progress-chart-container').addClass('_hidden');
      }
    });
  }

  getRegionId($region) {
    let _this = this;
    $region = $region || _this.$regions.filter('._selected');

    if ((!$region || !$region.length) || $region.is('._lvl-0')) {
      return { id: null, idNum: null };
    }

    return {
      id: $region.data('region-id'),
      idNum: formatZeroNum(+$region.data('region-id').split('-')[ 1 ]),
    };
  }

  getChildrenRegions($parentRegion) {
    let _this = this;
    let lvl = +$parentRegion.data('region-lvl');

    return (lvl < 2) ? $parentRegion.children(_this.$regions) : $parentRegion;
  }

  getRegionBounds($region) {
    return $region[ 0 ].getBoundingClientRect();
  }

  getZoomMult(bounds) {
    let _this = this;
    let $mapWrapp = _this.$mapWrapp;

    let wrappWidth = $mapWrapp.innerWidth();
    let wrappHeight = $mapWrapp.innerHeight();

    let wDiff = wrappWidth / bounds.width;
    let hDiff = wrappHeight / bounds.height;

    let wrappSize, regionSize;
    if (wDiff < hDiff) {
      wrappSize = wrappWidth;
      regionSize = bounds.width;
    } else {
      wrappSize = wrappHeight;
      regionSize = bounds.height;
    }

    return +(wrappSize / regionSize * _this.pan.zoom * .8).toFixed(2);
  }

  getReadinessLvl(percent) {
    percent = +percent || 0;
    let lvl = 1;

    if (percent >= 0 && percent < 30) {
      lvl = 1;
    } else if (percent >= 30 && percent < 50) {
      lvl = 2;
    } else if (percent >= 50 && percent < 80) {
      lvl = 3;
    } else if (percent >= 80 && percent < 100) {
      lvl = 4;
    } else if (percent >= 100) {
      lvl = 5;
    }
    return lvl;
  }

  getDataObject(data, indicator) {
    return data.find((item) => item.name === 'Столбец' + indicator) || { value: 0 };
  }

  getSelectedRegionData(regionFullId) {
    let _this = this;
    const $selectedRegion = _this.$regions.filter('[data-region-id="' + regionFullId + '"]');
    const currentYear = +_Objects.Timeline.getValue();
    if ($selectedRegion.hasClass(`data-set-${currentYear}`)) {
      _this.setRegionsInfo($selectedRegion);
      _this.setRightPanelCharts(regionFullId, true);
      return new Promise((resolve, reject) => {
        resolve();
      });
    }

    return Promise.resolve().then(() => {
      if (!regionFullId) {
        // if (_this.inited) resolve1();
        // return false;
        return false;
      }

      const mapData = _Objects.MapData;
      const [ structureName, structureId ] = regionFullId.split('-');
      const structureStr = (structureName !== 'obj' && structureId < 10) ? '0' + structureId : '' + structureId;
      if (!_this.queryData || !_this.queryData[ currentYear ].length) return false;

      let loadingRegionsIdx = [];
      _this.getChildrenRegions($selectedRegion).each(function (i, region) {
        loadingRegionsIdx.push($(region).data('region-id'));
      });
      let $loadingRegionsGridCell = _this.$mapGridCell.filter((i, cell) => {
        return loadingRegionsIdx.indexOf($(cell).data('region-id')) > -1;
      });

      // _this.isLoadingStructure = true;
      return Promise.resolve().then(() => {
        const currentYearData = mapData.getCurrentYearData();
        if (structureName === 'fo') {
          const selectedDistrict = mapData.findStructureElementByName('district', structureStr);
          $loadingRegionsGridCell.addClass('_loading');
          let neededSubjects = [];
          if (!mapData.hasProperty('subjectsData')) {
            currentYearData[ 'subjectsData' ] = {};
            neededSubjects = selectedDistrict.subjects;
          } else {
            neededSubjects = selectedDistrict.subjects.filter(({ name }) => currentYearData[ 'subjectsData' ][ name ] === undefined);
          }
          const districtObjects = selectedDistrict.subjects.reduce((acc, subj) => acc.concat(subj.objects), []);
          let neededDistrictObjects = [];
          if (!mapData.hasProperty('objectsData')) {
            currentYearData[ 'objectsData' ] = {};
            neededDistrictObjects = districtObjects;
          } else {
            neededDistrictObjects = districtObjects.filter(({ name }) => currentYearData[ 'objectsData' ][ name ] === undefined);
          }

          let queries = [];

          if (neededSubjects.length) {
            const queryParams = {
              id: neededSubjects.map(({ yearId }) => yearId),
              year: '' + currentYear,
            };
            queries.push(queryChart(queryParams).then(({ data }) => {
              mapData.setStructureIndicatorStaticData('subject', data.chart, neededSubjects);
            }));
          }
          if (neededDistrictObjects.length) {
            const queryParams = {
              id: neededDistrictObjects.map(({ yearId }) => yearId),
              year: currentYear,
            };
            queries.push(queryChart(queryParams).then(({ data }) => {
              mapData.setStructureIndicatorStaticData('object', data.chart, neededDistrictObjects);
              _this.setRightPanelInfo(regionFullId);
            }));
          } else {
            _this.setRightPanelInfo(regionFullId);
          }
          if (!mapData.hasElementDynamicData('district', structureStr)) {
            const queryParams = {
              id: selectedDistrict.monthId,
              year: currentYear,
            };
            _this.RightPanel.$container.find('.js-region-charts-item').filter('_dynamic').removeClass('_hidden');
            const $chart = _this.RightPanel.$container.find('.js-chart:visible').filter('._dynamic');
            const $chartBox = $chart.closest('.js-chartbox');
            $chartBox.addClass('_loading');
            queries.push(queryChart(queryParams).then(({ data }) => {
              mapData.setStructureIndicatorDynamicData('district', selectedDistrict.name, data, 'month');
              $chartBox.removeClass('_initing _loading').addClass('_inited');
              _this.setRightPanelCharts(regionFullId, true);
            }));
          } else {
            _this.setRightPanelCharts(regionFullId, true);
          }

          return Promise.all(queries);
        } else if (structureName === 'subj') {
          const selectedSubject = mapData.findStructureElementByName('subject', structureStr);
          if (!mapData.hasProperty('subjectsData')) {
            currentYearData[ 'subjectsData' ] = {};
          }
          $loadingRegionsGridCell.addClass('_loading');
          let neededObjects = [];
          if (!mapData.hasProperty('objectsData')) {
            neededObjects = selectedSubject.objects;
          } else {
            neededObjects = selectedSubject.objects.filter(({ name }) => currentYearData[ 'objectsData' ][ name ] === undefined);
          }
          let queries = [];

          if (neededObjects.length) {
            const queryParams = {
              id: neededObjects.map(({ yearId }) => yearId),
              year: '' + currentYear,
            };
            queries.push(queryChart(queryParams).then(({ data }) => {
              if (!mapData.hasProperty('objectsData')) {
                currentYearData[ 'objectsData' ] = {};
              }
              mapData.setStructureIndicatorStaticData('object', data.chart, neededObjects);
            }));
          }
          if (currentYearData[ 'subjectsData' ][ structureStr ] === undefined) {
            currentYearData.subjectsData[ structureStr ] = {};
            const queryParams = {
              id: selectedSubject.yearId,
              year: '' + currentYear,
            };
            queries.push(queryChart(queryParams).then(({ data }) => {
              currentYearData.subjectsData[ structureStr ].staticData = {};
              currentYearData.subjectsData[ structureStr ].staticData = data.chart[ 0 ].axisX[ 0 ].axisY;
            }));
          } else if (queries.length === 0) {
            _this.setRightPanelInfo(regionFullId);
          }
          if (!mapData.hasElementDynamicData('subject', structureStr)) {
            const queryParams = {
              id: selectedSubject.monthId,
              year: '' + currentYear,
            };
            _this.RightPanel.$container.find('.js-region-charts-item').filter('_dynamic').removeClass('_hidden');
            const $chart = _this.RightPanel.$container.find('.js-chart:visible').filter('._dynamic');
            const $chartBox = $chart.closest('.js-chartbox');
            $chartBox.addClass('_loading');
            queries.push(queryChart(queryParams).then(({ data }) => {
              mapData.setStructureIndicatorDynamicData('subject', selectedSubject.name, data, 'month');
              $chartBox.removeClass('_initing _loading').addClass('_inited');
              _this.setRightPanelCharts(regionFullId, true);
            }));
          } else {
            _this.setRightPanelCharts(regionFullId, true);
          }

          return Promise.all(queries).then(() => {
            _this.setRightPanelInfo(regionFullId);
          });
        }
      }).then(() => {
        // _this.isLoadingStructure = false;
        $selectedRegion.addClass(`data-set-${currentYear}`);
        $loadingRegionsGridCell.removeClass('_loading');
        _this.setRegionsInfo($selectedRegion);
      });
    }).then(() => {
      _this.setRegionsInfo();
    });
  }

  getMapData() {
    let _this = this;
    const currentYear = +_Objects.Timeline.getValue();
    const params = {
      structureType: 'TYPE_DISTRICT',
      year: currentYear,
      indicator: 'Столбец9',
      subjType: 'TYPE_SUBJECT',
      subjIndicator: 'Столбец14',
      indicatorValue: '0'
    };
    const mapData = _Objects.MapData;
    const currentYearData = mapData.getCurrentYearData();
    let $mapGridCellLvl1 = _this.$mapGridCell.filter('[data-region-lvl="1"]');
    $mapGridCellLvl1.addClass('_loading');
    // _this.isLoadingStructure = true;
    return Promise.resolve().then(() => {
      if (!(Object.keys(currentYearData).length)) {
        return queryStructureFilter(params)
          .then(({ data }) => {
            if (data) {
              _this.queryData[ currentYear ] = data.structure;
              let convertedData = RegionMap.convertData(data);
              _Objects.Search.setLoading();
              mapData.setStructureData(convertedData);
              const districts = mapData.getStructureElements('district');
              const districtsIds = districts.map((district) => district.yearId);
              const queryParams = {
                id: districtsIds,
                year: '' + currentYear,
              };
              if (queryParams.id.length) {
                return queryChart(queryParams).then(({ data }) => {
                  mapData.setStructureIndicatorStaticData('district', data.chart, districts);
                });
              }
            }
          })
          .then(() => {
            return false;
          });
      } else {
        return true;
      }
    }).then((hasData) => {
      $mapGridCellLvl1.removeClass('_loading');
      return hasData;
    });
  }

  updateMapData() {
    let _this = this;
    if (_this.inited) {
      _this.resetData();
      _this.unfilterRegions();
    }
    return _this.getMapData().then((hasData) => {
      if (!hasData) {
        $('.js-reports-generator').data('_reportGenerator').setInputs();
      }

      _this.initObjectsDots();
      if (hasData && _this.regionLevel > 1) {
        let $selectedRegion = _this.$regions.filter('._selected');
        return _this.getSelectedRegionData($selectedRegion.data('region-id')).then(() => {
          _this.initMapDots();
          _this.initSelecting();
        });
      } else {
        _this.setRegionsInfo();
        _this.initMapDots();
        _this.initSelecting();
      }
      _this.inited = true;
    }).then(() => {
      setTimeout(() => _this.updateObjectsDotsLocation(), 500);
    });
  }

  setMapSize() {
    let _this = this;
    let $mapWrapp = _this.$mapWrapp;

    $mapWrapp.css({
      'height': $mapWrapp.innerWidth() / 1.77,
    });
  }

  setDotsScale(updateObjectsDots) {
    let _this = this;
    let $mapDots = _this.$mapGridDots.add(_this.$mapObjectsDots);
    let zoom = _this.pan.zoom;

    if (!$mapDots || !$mapDots.length) return false;
    let scale = 1 / zoom;
    $mapDots.css({
      '-webkit-transform': `scale(${scale})`,
      '-ms-transform': `scale(${scale})`,
      'transform': `scale(${scale})`,
    });

    if (!updateObjectsDots) {
      setTimeout(() => {
        let $charts = $mapDots.find('.js-chart:visible');
        $charts.trigger('charts.resize');
      }, 300);
    }
  }

  filterRegions() {
    let _this = this;
    let filters = _this.filters;

    let $currRegions = _this.$regions.filter('._visible._inited').not('._lvl-0');
    //$currRegions.removeClass('_spending');
    let $mapDots = _this.$mapGridDots.add(_this.$mapObjectsDots);

    _this.unfilterRegions();
    const toggleValue = _this.toggleValue;
    const neededClass = (toggleValue === 'readiness') ? '' : '_spending';
    const neededAttribute = `${toggleValue}-percent`;
    let $filteredRegions = $currRegions.filter((i, region) => {
      $(region).addClass(neededClass);
      let regionReadyPerc = +$(region).data(neededAttribute);
      if (regionReadyPerc > 100) {
        regionReadyPerc = 100;
      }
      return regionReadyPerc < filters.ready.min || regionReadyPerc > filters.ready.max;
    });

    // if (!$filteredRegions || !$filteredRegions.length) return false;
    let filteredIdx = $.makeArray($.map($filteredRegions, (region) => $(region).data('region-id'))) || [];

    let $filteredMapDots = $mapDots.filter((i, dot) => {
      let dotReadyPerc = $(dot).data('readiness-percent');
      let regionId = $(dot).data('parent-id') || $(dot).data('region-id');
      return dotReadyPerc
        ? +dotReadyPerc < filters.ready.min || +dotReadyPerc > filters.ready.max
        : filteredIdx.indexOf(regionId) > -1;
    });

    $.each($filteredRegions, (i, region) => {
      $(region).addClass('_filtered');
    });
    $filteredMapDots.addClass('_filtered');

  }

  unfilterRegions() {
    let _this = this;
    let $regions = _this.$regions;
    let $mapDots = _this.$mapGridDots.add(_this.$mapObjectsDots);

    $.each($regions, (i, region) => {
      $(region).removeClass('_filtered');
      $(region).removeClass('_spending');
    });
    $mapDots.removeClass('_filtered');
  }

  updateMapDots() {
    const _this = this;
    const $mapGridCells = _this.$mapGridCell.filter(`[data-region-lvl="${_this.regionLevel}"]`);
    const $mapDots = $mapGridCells.find('.map-dot');
    const toggleValue = _this.toggleValue;

    $.each($mapDots, (i, mapDot) => {
      const $currDot = $(mapDot);
      const $dotChart = $currDot.find('.js-chart');
      let graphData = null;
      if (toggleValue === 'readiness') {
        graphData = $dotChart.data('readinessData');
      } else {
        graphData = $dotChart.data('spendingData');
      }
      $dotChart.data('chartData', graphData);
      const _chart = Chart.get($currDot.data('region-id'));
      if (_chart) {
        _chart.initChartData();
        _chart.show();
      } else {
        return;
      }

      let dotReadyList = $currDot.find('.js-map-dot-readiness-list');
      let readyArr = graphData.slice().reverse();
      _this.fillDotList(dotReadyList, readyArr);

    });
  }

  resetFilters() {
    let _this = this;
    let $readyRanger = _this.$readyRanger;

    _this.filters.ready.min = 0;
    _this.filters.ready.max = 100;
    $readyRanger[ 0 ].noUiSlider.set($.map(_this.filters.ready, (item) => item));

    let $regions = _this.$regions;
    let $mapDots = _this.$mapGridDots.add(_this.$mapObjectsDots);
    $.each($regions, (i, region) => {
      $(region).removeClass('_filtered');
    });
    $mapDots.removeClass('_filtered');
  }

  static convertData({structure, emptySubjects}) {
    const districts = [];
    const subjects = [];
    const objects = [];
    const searchItems = [];
    const currentYear = +_Objects.Timeline.getValue();
    const normalizedEmptySubjects = emptySubjects.map(({id}) => id);

    structure.forEach((district) => {
      if (district.childList) {
        const districtSearchInfo = { id: district.id, name: district.name, meta: district.meta };
        districtSearchInfo.subjects = [];
        district.childList.forEach((subject) => {
          const isEmpty = normalizedEmptySubjects.includes(subject.id);
          if (/*!isEmpty &&*/ subject.childList) {
            const subjectSearchInfo = {
              id: subject.id,
              name: subject.name,
              parentName: district.name,
              meta: subject.meta,
              isEmpty,
            };
            subjectSearchInfo.objects = [];
            subject.childList.forEach((object) => {
              if (object.childList) {
                const parsedMeta = JSON.parse(object.meta);
                if (parsedMeta && parsedMeta.name) {
                  const objectSearchInfo = {
                    id: object.id,
                    name: object.name,
                    parentName: subject.name,
                    meta: object.meta,
                    xConv: object.conv_lng,
                    yConv: object.conv_lat,
                    fromCurrentYear: +parsedMeta.year === currentYear,
                    beforeCurrentYear: +parsedMeta.year <= currentYear
                  };
                  object.childList.forEach((filter) => {
                    RegionMap.parseElementName(filter, objectSearchInfo);
                  });
                  if (objectSearchInfo.beforeCurrentYear) {  // Если объект включен в систему в текущий год или до него
                    subjectSearchInfo.objects.push(objectSearchInfo);
                    objects.push(objectSearchInfo);
                    searchItems.push({ ...objectSearchInfo, type: 'obj' });
                  }
                }
              } else {
                RegionMap.parseElementName(object, subjectSearchInfo);
              }
            });
            districtSearchInfo.subjects.push(subjectSearchInfo);
            const subjectData = { ...subjectSearchInfo, meta: subject.meta };
            subjects.push(subjectData);
            searchItems.push({ ...subjectData, type: 'subj' });
          } else {
            RegionMap.parseElementName(subject, districtSearchInfo);
          }
        });
        const districtData = { ...districtSearchInfo, meta: district.meta };
        districts.push(districtData);
        searchItems.push({ ...districtData, type: 'fo' });
      }
    });
    searchItems.sort((a, b) => {
      if (a.id > b.id) return 1;
      else if (a.id === b.id) return 0;
      return -1;
    });
    return { districts, subjects, objects, searchItems };
  }

  static parseElementName(structureElement, resultObject) {
    switch (structureElement.name) {
      case 'Год':
        resultObject.yearId = structureElement.id;
        break;
      case 'Квартал':
        resultObject.quarterId = structureElement.id;
        break;
      case 'Месяц':
        resultObject.monthId = structureElement.id;
        break;
      case 'Неделя':
        resultObject.weekId = structureElement.id;
        break;
      case 'Дата':
        resultObject.dateId = structureElement.id;
        break;
      default:
        break;
    }
  }
}

export class MapTool {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this.$toolBox = _this.$container.find('.map-tool__tool');
    _this.$toolBtn = _this.$container.find('.map-tool__btn');
    _this.$toolValue = _this.$container.find('.js-map-btn-value');
    _this.isActive = false;

    _this.init();
  }

  init() {
    let _this = this;
    let $tool = _this.$container;
    let $btn = _this.$toolBtn;

    if (_this.$toolValue.length) _this.initValue();

    $btn.on('click touchend', (e) => {
      e.preventDefault();

      if (_this.isActive) _this.hide();
      else _this.show();
    });

    $(document).on('click touchend', (e) => {
      let $target = $(e.target);

      if (!$target.closest($tool).length) {
        _this.hide();
      }
    });
  }

  initValue() {
    let _this = this;
    // let $container = _this.$container;
    let $toolInp = _this.$container.find('.js-map-tool-input');

    if ($toolInp.data('_ranger')) {
      let _ranger = $toolInp.data('_ranger');

      _ranger._ranger.noUiSlider.on('set', function () {
        _this.setToolValue(_ranger._ranger.noUiSlider.get());
      });

      _this.setToolValue(_ranger._ranger.noUiSlider.get());
    }
  }

  show() {
    let _this = this;
    let $tool = _this.$container;
    let $box = _this.$toolBox;
    let $btn = _this.$toolBtn;

    if (_this.isActive) return;

    $box.add($btn).add($tool).addClass('_active');
    $tool.trigger('tool.showed');
    _this.isActive = true;
  }

  hide() {
    let _this = this;
    let $tool = _this.$container;
    let $box = _this.$toolBox;
    let $btn = _this.$toolBtn;

    if (!_this.isActive) return;

    $box.add($btn).add($tool).removeClass('_active');
    $tool.trigger('tool.hidden');
    _this.isActive = false;
  }

  setToolValue(value) {
    let _this = this;

    _this.$toolValue.text(+value || '');
  }
}

export class ObjectPage {
  constructor(selector) {
    let _this = this;

    _this.$container = $(selector);
    _this.isActive = false;
    _this._container = this;

    _this.$container.data('_objectPage', _this._container);

    _this.init();
  }

  init() {
    let _this = this;
    let $objPage = _this.$container;

    $objPage.on('showed', (e) => {
      _this.onPageShowed();
    });
    $objPage.on('hidden', (e) => {
      _this.onPageHidden();
    });
  }

  setObjectData(objData = {}) {
    let _this = this;
    let $objPage = _this.$container;

    if (!objData) return;

    $objPage.data('region-id', objData.id).attr('data-region-id', objData.id);
    $objPage.data('parent-region-id', objData.parentId).attr('data-parent-region-id', objData.parentId);
  }

  show() {
    let _this = this;
    let $objPage = _this.$container;

    if (_this.isActive) return;
    _this.isActive = true;

    $objPage.addClass('_active');
    $('html').addClass('object-page-active');
    $objPage.trigger('showed');
  }

  hide() {
    let _this = this;
    let $objPage = _this.$container;

    if (!_this.isActive) return;
    _this.isActive = false;

    $objPage.removeClass('_active');
    $('html').removeClass('object-page-active');
    $objPage.trigger('hidden');
  }

  onPageShowed() {
    let _this = this;
    let $objPage = _this.$container;
    // const $periodFilter = $('.js-chart-filter[data-select-id="period"]');
    // $periodFilter.addClass('_hidden');

    let $objPagePhotoSlider = $objPage.find('.js-slider.slick-initialized');
    $.each($objPagePhotoSlider, (i, slider) => {
      $(slider).slick('setPosition');
    });
  }

  onPageHidden() {
    // const $periodFilter = $('.js-chart-filter[data-select-id="period"]');
    // $periodFilter.removeClass('_hidden');
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/regionMap.js